import Raven from 'raven-js';
import { of } from 'rxjs/observable/of';
import { empty } from 'rxjs/observable/empty';
import { fromPromise } from 'rxjs/observable/fromPromise';
import { filter } from 'rxjs/operators/filter';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { startWith } from 'rxjs/operators/startWith';
const isAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};
export const getPayloadData = action => {
  if (action.payload && action.payload.data) {
    return action.payload.data;
  }
  return action.payload;
};

/**
 * @deprecated Consider using thunks instead. In most cases, this function is
 * used as an over-complicated and untested way of making one-off requests to an
 * API, that is notoriously hard to maintain and type correctly.
 *
 * Underlying observables are a much more powerful mechanism that allows
 * subscribing to multiple values arriving over time (as in WebSocket streams -
 * as opposed to making N requests to retrieve multiple pages of data) or
 * cancelling previous request (which may be possible with AbortController).
 * This function however, does not utilise these features.
 */
export function requestEntity(requestEpicDescriptor) {
  return ($action, {
    getState
  }) => $action.ofType(requestEpicDescriptor.getInitiatingActionType()).pipe(filter(() => {
    return requestEpicDescriptor.getRequestStatusTypeFilters().indexOf(requestEpicDescriptor.getRequestStatus(getState())) !== -1;
  }), mergeMap(action => fromPromise(requestEpicDescriptor.makeAPICall(...[getPayloadData(action), requestEpicDescriptor.getAdditionalParamsFromState(getState())])).pipe(map(response => requestEpicDescriptor.getSuccessAction()(...[response, getPayloadData(action)])), catchError(error => {
    if (requestEpicDescriptor.sc404isSuccess && error.status === 404) {
      return of(requestEpicDescriptor.getSuccessAction()(...[error, getPayloadData(action)]));
    }
    if (error.status === 0 && isAcceptanceTest()) {
      return empty();
    }
    Raven.captureException(new Error(`API Failure: ${error.toString()}`), {
      fingerprint: [requestEpicDescriptor.apiFunction.name],
      extra: {
        status: error.status,
        statusText: error.statusText
      }
    });
    return of(requestEpicDescriptor.getFailureAction()(...[error, getPayloadData(action)]));
  }), startWith(requestEpicDescriptor.getRequestAction()(...[getPayloadData(action)])))));
}